<template>


    <div class="children-container">
      <div class="children-module-name"><span>支付宝支付</span></div>
      <div class="children-module-info">
        <a-result
    status="success"
    title="支付成功"
    sub-title=""
  >
    <template #extra>
      <a-button key="console" type="primary" @click="goShop">
        小鼠商城
      </a-button>
      <a-button key="buy" @click="goOrder">
        我的订单
      </a-button>
    </template>
  </a-result>
      </div>
    </div>
  </template>
  
  <script>
    import * as commonApi from '@/commonApi';
  
    export default {
      data() {
        
        return {
          formModel: {
          }
        }
      },
      mounted() {
      },
      methods: {
        goShop() {
            window.location.replace('/shop/index.html');
        },
        goOrder() {
            this.$router.replace({ path: '/product-list' });
        }
        
      },
    };
  </script>
  
  <style lang="less">

  </style>